import React from 'react';

function HelpRequestTableHeader(props) {
    return (
        <thead className="team-head admin-help">
        <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Edit</th>
        </tr>
        </thead>
    )
}

export default HelpRequestTableHeader;
